import { useState, useCallback } from "react";
import { User } from "../types/user.d";
import HotelService from "../api/hotelService";

/**
 * Custom hook to fetch and manage users for a specific hotel.
 * @param hotelId - ID of the hotel whose users are to be fetched.
 * @returns An array of users and a function to refresh the users list.
 */
export const useHotelUsers = (hotelId: number | null) => {
    const [users, setUsers] = useState<User[]>([]);

    const fetchUsers = useCallback(async () => {
        if (!hotelId) return;

        try {
            const hotelUsers = await HotelService.getUsersByHotelId(hotelId);
            setUsers(hotelUsers);
        } catch (error: any) {
            console.error("Error fetching users:", error.message);
            setUsers([]);
        }
    }, [hotelId]);

    return { users, fetchUsers };
};
